// Import Swiper and required modules
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Keyboard } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

var $ = jQuery;
$(document).ready(function ($) {
    // Hero Banner
    if($('.bnr-hero').length > 0){
        new Swiper('.bnr-hero .swiper', {
            modules: [Navigation, Pagination, Keyboard],
            loop: false,
            slidesPerView: 1,
            navigation: {
                nextEl: ".bnr-hero .swiper-button-next",
                prevEl: ".bnr-hero .swiper-button-prev",
            },
            pagination: {
                el: ".bnr-hero .swiper-pagination",
                clickable: true,
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            autoHeight: true
        });
    }


    // Testimonial Block
    if($('.blk-testimonial').length > 0){
        $('.blk-testimonial').each(function(){
            const numSlider = $(this).attr('data-num');
            const swiperContainer = $(this).find('.swiper');
            const nextButton = $(this).find('.swiper-button-next');
            const prevButton = $(this).find('.swiper-button-prev');


            new Swiper(swiperContainer[0], {
                modules: [Navigation, Pagination, Keyboard],
                loop: true,
                slidesPerView: 1,
                spaceBetween: 16,
                breakpoints: {
                    1024: {
                        slidesPerView: parseInt(numSlider, 10),
                        spaceBetween: 24,
                    },
                    768: {
                        slidesPerView: parseInt(numSlider, 10) > 1 ? 2 : 1,
                        spaceBetween: 16,
                    },
                },
                navigation: {
                        nextEl: nextButton[0],
                        prevEl: prevButton[0],
                    },
                allowTouchMove: true,
                keyboard: {
                    enabled: true,
                },
            });
        }) 
    }

    // Similar Block in Article page
    if($('.blk-similar-articles').length > 0){
        new Swiper('.blk-similar-articles .swiper', {
            modules: [Navigation, Pagination, Keyboard],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
            },
            navigation: {
                nextEl: ".blk-similar-articles .swiper-button-next",
                prevEl: ".blk-similar-articles .swiper-button-prev",
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            autoHeight: true
        });
    }

    // News Carousel Block
    if($('.blk-news-carousel').length > 0){
        new Swiper('.blk-news-carousel .swiper', {
            modules: [Navigation, Pagination, Keyboard],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                },
            },
            navigation: {
                nextEl: ".blk-news-carousel .swiper-button-next",
                prevEl: ".blk-news-carousel .swiper-button-prev",
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            autoHeight: true
        });
    }


    setTimeout(function() {
        matchHeight();
    }, 500);
});


$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});

// Function to equalize the height of elements within a container
function matchHeight() {
    // Check if there are any elements with the class 'match-height-wrapper'
    if ($(".match-height-wrapper").length > 0) {
        // Iterate over each 'match-height-wrapper' container
        $(".match-height-wrapper").each(function() {
            // Find all elements with the class 'match-height' inside the current wrapper
            const elements = $(this).find('.match-height');

            // Initialize a variable to track the maximum height
            let maxHeight = 0;

            // Iterate over each 'match-height' element to determine the tallest one
            elements.each(function() {
                // Get the current element's height, including padding, border, and margin
                const currentHeight = $(this).outerHeight();

                // Update maxHeight if the current element's height is greater
                if (currentHeight > maxHeight) {
                    maxHeight = currentHeight;
                }
            });

            // Set all 'match-height' elements to the tallest height
            elements.height(maxHeight);
        });
    }
}
